import request from '@/utils/request'

/**
 * 获取文章详情
 */
export const getartInfo = (params) => {
  return request({
    url: '/yslt-server-information/information/info',
    params
  })
}

/**
 * 收藏咨询
 */
export const collectAdvisory = data => {
  return request({
    url: '/yslt-server-interaction/api/v1/collect/add',
    method: 'POST',
    data
  })
}

/**
 * 点赞咨询
 */
export const likeAdvisory = data => {
  return request({
    url: '/yslt-server-interaction/api/v1/like/add',
    method: 'POST',
    data
  })
}

/**
 * 评论咨询
 */
export const artComment = data => {
  return request({
    url: '/yslt-server-interaction/api/v1/comment/add',
    method: 'POST',
    data
  })
}

/**
 * 获取评论列表
 * @param {params} { topicId:评论id，pageNo:当前页数，pageSize:每页数量 }
 */
export const queryCommentList = params => {
  return request({
    url: '/yslt-server-interaction/api/v1/comment/list',
    params
  })
}

/**
 * 获取评论点赞数
 * @param {params} { topicId: 项目ID }
 */
export const queryCommentLikeTotal = params => {
  return request({
    url: '/yslt-server-interaction/api/v1/comment/likeTotal',
    params
  })
}

/**
 * 随机获取作品
 */
export const getRecWorksRandom = params => {
  return request({
    url: '/yslt-server-admin/api/v1/appIndex/getRecWorksRandom',
    method: 'POST',
    params
  })
}
/**
 * 获取资讯列表
 */
export const queryInformationList = params => {
  return request({
    url: '/yslt-server-information/information/page',
    params
  })
}
/**
 * 名画赏析详情
 */
export const getFamousDetailById = params => {
  return request({
    url: '/yslt-server-interaction/api/v1/famous/detailById',
    method: 'POST',
    params
  })
}
/**
 * 名画赏析往期
 */
export const getFamousHistory = params => {
  return request({
    url: '/yslt-server-interaction/api/v1/famous/history',
    method: 'POST',
    params
  })
}
